import { render, staticRenderFns } from "./VehicleRegister.vue?vue&type=template&id=74c25286&scoped=true&"
import script from "./VehicleRegister.vue?vue&type=script&lang=js&"
export * from "./VehicleRegister.vue?vue&type=script&lang=js&"
import style0 from "./VehicleRegister.vue?vue&type=style&index=0&id=74c25286&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c25286",
  null
  
)

export default component.exports